import { branchItemState } from "./item_state";

export const branchSubScriptStateinitial = {
  stores: {
    data: {
      branch_id: "string / 지점 ID",
      prepay_items: [],
      subs_items: [branchItemState],
      etc_items: [],
    },
  },
};
